"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "¿Cómo puedo inscribirme en un curso?",
  answer: "El proceso es muy sencillo. Puedes inscribirte directamente desde nuestra página de Cursos seleccionando el programa de tu interés o contactarnos vía WhatsApp para recibir asesoría personalizada en tu matrícula."
}, {
  question: "¿Qué metodología de enseñanza utilizan?",
  answer: "Combinamos clases teóricas con proyectos prácticos reales. Nuestro enfoque minimalista busca eliminar distracciones para que te concentres en lo que realmente importa: aprender haciendo."
}, {
  question: "¿Necesito conocimientos previos para empezar?",
  answer: "Contamos con niveles desde principiante hasta avanzado. En la descripción de cada curso encontrarás los requisitos previos recomendados para asegurar que aproveches al máximo la experiencia."
}];
export default function CommonQuestions() {
  return <section data-section-id="224876" id="preguntas-frecuentes" className="relative w-full bg-slate-50 text-foreground py-24 px-4 md:px-8 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" />

      <div className="relative z-10 max-w-3xl mx-auto flex flex-col items-center">
        <div className="text-center mb-16 space-y-4">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter uppercase text-foreground">
            Preguntas <span className="text-primary">Frecuentes</span>
          </h2>
          <p className="font-default text-muted-foreground text-lg md:text-xl max-w-xl mx-auto">Resolvemos tus dudas para que comiences tu formación en CENTRO COSMOS con total claridad.</p>
        </div>

        <Accordion type="single" collapsible className="w-full flex flex-col gap-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`faq-${i}`} data-index={i} className="group border border-border/60 rounded-xl px-6 py-2 bg-white transition-all duration-500 ease-out data-[state=open]:bg-white data-[state=open]:border-primary/30 data-[state=open]:shadow-xl data-[state=open]:shadow-black/5">
              <AccordionTrigger className="font-default text-lg md:text-xl font-bold text-left text-foreground hover:no-underline hover:text-primary transition-colors py-4 [&[data-state=open]>svg]:text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-default text-muted-foreground text-base leading-relaxed pb-6 pt-2">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}